import {Component, Input} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {DeleteConfirmationComponent} from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import {BzgModalRef, BzgModalService} from 'bz-genome-angular';
import {Observable, Subscription} from 'rxjs';
import {selectUserGroupsList} from '../store/selectors/user-groups-list.selector';
import { GetCurrentUserGroup, StartNewUserGroup } from '../store/actions/current-user-group.actions';
import {DeleteUserGroups} from '../store/actions/user-groups-list.actions';
import { RequestPendingChanges, ResetProperties } from 'app/core/store/actions/pending-changes.actions';
import { EPendingChangesSelectedAction } from 'app/core/models/pending-changes.enum';
import {getCurrentUserGroup} from '../store/selectors/current-user-groups.selector';
import {EUserGroupMenuOptions} from '../../core/user-groups.enum';
import { selectPendingChangeAction } from 'app/core/store/selectors/pending-changes.selector';
import { IAppState } from 'app/IAppState';

@Component({
    selector: 'user-groups-list',
    templateUrl: 'user-groups-list.component.html',
    styleUrls: ['user-groups-list.component.scss']
})

export class UserGroupsListComponent {
  @Input() menuOptions: {[key:string]: any};
    public searchValue = '';
    public userGroups: Array<IUserGroup>;
    public selectedUserGroup: any;
    public userGroupsList$: Observable<IUserGroup[]>
    public userGroupCurrent$: Observable<IUserGroup>
    public filterBy = 'displayName';
    public deleteActivated = false;
    public deletetionArray: Array<Guid> = [];
    private subscriptionCurrentUserGroup: Subscription;
    private _pendingChangesActionSupscription: Subscription;
    private _nextGuidSuscription: Subscription;
    private _nextSelectedGroup: IUserGroup;
    private _createNewFlag = false;
    public modalRef: BzgModalRef;
    public userGroupMenuOptions = EUserGroupMenuOptions;

    constructor(private _modalService: BzgModalService,
        private _store: Store<IAppState>) {
        this.userGroupsList$ = this._store.pipe(select(selectUserGroupsList));
        this.userGroupCurrent$ = this._store.pipe(select(getCurrentUserGroup));
        this.userGroupCurrent$.subscribe((current) => {
            if (!this.selectedUserGroup || (current.id && current.id !== this.selectedUserGroup.id)) {
                this.selectedUserGroup = current;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscriptionCurrentUserGroup) {
            this.subscriptionCurrentUserGroup = null;
        }
        if (this._pendingChangesActionSupscription) {
            this._pendingChangesActionSupscription.unsubscribe();
        }
        if (this._nextGuidSuscription) {
            this._nextGuidSuscription.unsubscribe();
        }
    }

    ngOnInit() {
        this._pendingChangesValidationAction();
    }

    public cancelDeletion() {
        this.deleteActivated = false;
        this.deletetionArray = [];
    }

    public addOrRemoveFromDeletionList(id: Guid, checked: boolean) {
        if (typeof (checked) === 'boolean') {
            if (checked) {
                this.deletetionArray.push(id);
            } else {
                _.remove(this.deletetionArray, item => item === id);
            }
        }
    }

    public showDeleteConfirmation() {
        const modal = this._modalService.open(DeleteConfirmationComponent, {
            closeOnBackdropClick: false,
            closeOnRouterNavigation: true,
            data: {
                title: 'USER_GROUPS.DELETE_USER_GROUPS',
                message: 'USER_GROUPS.CONFIRM_DELETE',
                button: 'USER_GROUPS.DELETE_OK_BUTTON'
            }
        });
        modal.afterClosed().subscribe((result: string) => {
            if (result === 'delete') {
                this.deleteUserGroups();
            }
        })
    }

    public deleteUserGroups() {
        this._store.dispatch(new DeleteUserGroups(this.deletetionArray));
        this.selectedUserGroup = null;
        this.deleteActivated = false;
    }

    public setCurrentUserGroup(userGroup: IUserGroup) {
        if (this.selectedUserGroup) {
            this._nextSelectedGroup = userGroup;
            this._store.dispatch(new RequestPendingChanges(userGroup.id));
        } else {
            this.selectedUserGroup = userGroup;
            this._store.dispatch(new GetCurrentUserGroup(userGroup.id));
        }
    }

    public newUserGroupAction() {
        this.selectedUserGroup = null;
        this._createNewFlag = true;
        this._store.dispatch(new RequestPendingChanges());
    }

    private _pendingChangesValidationAction() {
        this._pendingChangesActionSupscription = this._store
          .pipe(select(selectPendingChangeAction))
          .subscribe((action: EPendingChangesSelectedAction) => {
            switch (action) {
              case EPendingChangesSelectedAction.CONTINUE:
                if (!this._createNewFlag) {
                  this.selectedUserGroup = this._nextSelectedGroup
                    ? this._nextSelectedGroup
                    : this.selectedUserGroup;
                  this._store.dispatch(
                    new GetCurrentUserGroup(this.selectedUserGroup.id)
                  );
                } else {
                  this._createNewFlag = false;
                  this._store.dispatch(new StartNewUserGroup());
                }

                break;
              case EPendingChangesSelectedAction.CANCEL:
                this._store.dispatch(new ResetProperties());
                break;
            }
          });
    }
}
